import { render } from "./DarkTextHeroShort.vue?vue&type=template&id=0a7ff8d0&scoped=true"
import script from "./DarkTextHeroShort.vue?vue&type=script&lang=js"
export * from "./DarkTextHeroShort.vue?vue&type=script&lang=js"

import "./DarkTextHeroShort.vue?vue&type=style&index=0&id=0a7ff8d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7ff8d0"]])

export default __exports__